import enviro from 'enviro';
import { getQueryParam } from '../_core/utils/commMethodOverrides';
export const useDisplayBannerOverride = () => {
  const displayBannerQueryParam = getQueryParam('displayUpgradeBanner');
  const qaEnvironment = enviro.isQa();
  return !!displayBannerQueryParam && qaEnvironment;
};